import { styled } from 'css-literal-loader/styled';
import withProps from 'recompose/withProps';

import PageSegment from './PageSegment';

const HeroImageSegment = withProps({ theme: 'dark' })(
  styled(PageSegment, null, "HeroImageSegment", require("./HeroImageSegment-HeroImageSegment.module.scss"), "hero-image-segment", "heroImageSegment"),
);

export default HeroImageSegment;
